const CUSTOM_DEBOUNCE_DELAY = 200;
const CUSTOM_BREAKPOINT_MEDIUM = 750;

function initializeAllComponents() {
    initCustomCursor();
    initCustomMobileSlider();
    initCustomRecentlyViewedSlider();
    initCustomProductSlider();
    initCustomSmoothScroll();
    initCustomSingleSlider();
}

document.addEventListener('DOMContentLoaded', initializeAllComponents);

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initializeAllComponents);
    document.addEventListener('shopify:block:select', initializeAllComponents);
    document.addEventListener('shopify:section:select', initializeAllComponents);
}


/****************************************
     遅延関数のJS
****************************************/
function customDebounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}


/****************************************
    メインビジュアルのスライダーJS
****************************************/
function initCustomSingleSlider() {
    const singleSliderSections = document.querySelectorAll('.c-singleslider__section');
    if (singleSliderSections.length) {
        setupCustomSingleSlider(singleSliderSections);
    }
};

function setupCustomSingleSlider(sections) {
    $(sections).each(function() {
        const $section = $(this);
        const $slick = $section.find('.c-singleslider__wrapper.slider');

       $slick.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button class="c-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse md-max-hidden"><span class="c-arrow__svg"></span></button>',
            nextArrow: '<button class="c-arrow__btn c-arrow__next animate-icon-horizontal md-max-hidden"><span class="c-arrow__svg"></span></button>',
            dots: true,
            focusOnSelect: true,
       });
    });
}


/****************************************
    商品一覧のJS
****************************************/
function initCustomProductSlider() {
    const productlSections = document.querySelectorAll('.c-productlist__section');
    if (productlSections.length) {
        setupCustomProductSlider(productlSections);
    }
};

function setupCustomProductSlider(sections) {
    $(sections).each(function() {
        const $section = $(this);
        const $slick = $(this).find('.c-productlist__inner.slider');

        const productNum = $slick.data('productNum');
        const slideNum = $slick.data('slideNum');
        
        let maxProductNum;
    
        const mediaQueryDesktop = window.matchMedia('(max-width: 1199px)');
        const mediaQueryTablet = window.matchMedia('(max-width: 999px)');
        const mediaQueryMobile = window.matchMedia('(max-width: 559px)');

        function updateSliderByProductCount() {
            if (mediaQueryTablet.matches) {
                maxProductNum = 2;
            } else if (mediaQueryDesktop.matches) {
                maxProductNum = 3;
            } else {
                maxProductNum = 4;
            }

            if (productNum <= maxProductNum || slideNum <= maxProductNum) {
                $section.addClass('c-stack-slick');
                if ($slick.hasClass('slick-initialized')) {
                    $slick.slick('unslick');
                }
            } else {
                $section.removeClass('c-stack-slick');
                if ($slick.hasClass('slick-initialized')) {
                    initializeSlick($slick);
                }
            }
        }

        updateSliderByProductCount();
        const debouncedUpdateSlider = customDebounce(updateSliderByProductCount, CUSTOM_DEBOUNCE_DELAY);
        mediaQueryDesktop.addListener(debouncedUpdateSlider);
        mediaQueryTablet.addListener(debouncedUpdateSlider);
        mediaQueryMobile.addListener(debouncedUpdateSlider);

        function initializeSlick($slick) {
            $slick.not('.slick-initialized').slick({
                autoplay: false,
                speed: 600,
                arrows: true,
                dots: false,
                slidesToShow: 4.65,
                slidesToScroll: 4,
                infinite: false,
                prevArrow: '<button class="c-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse md-max-hidden"><span class="c-arrow__svg"></span></button>',
                nextArrow: '<button class="c-arrow__btn c-arrow__next animate-icon-horizontal md-max-hidden"><span class="c-arrow__svg"></span></button>',
                responsive: [{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3.65,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2.65,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 560,
                        settings: {
                            slidesToShow: 1.45,
                            slidesToScroll: 1,
                            arrows: false,
                        }
                    }
                ]
            });
        }

        function initializeSliderByCondition() {
          if (!(productNum <= maxProductNum || slideNum <= maxProductNum)) {
              initializeSlick($slick);
          }
        }
        initializeSliderByCondition();

        const debouncedInitializeSlider = customDebounce(initializeSliderByCondition, CUSTOM_DEBOUNCE_DELAY);
        window.addEventListener('resize', debouncedInitializeSlider);
    });
};
window.initCustomProductSlider = initCustomProductSlider;


/****************************************
     おすすめセクションのモバイルスライドのJS
****************************************/
function initCustomMobileSlider() {
    const mobileSlideSections = document.querySelectorAll('.c-mobile-slide__section');
    if (mobileSlideSections.length) {
        setupCustomMobileSlider(mobileSlideSections);
    }
};

function setupCustomMobileSlider(sections) {
    $(sections).each(function() {
        const $section = $(this);
        const $slick = $(this).find('.c-mobile-slide__wrapper.slider');
        let isSlickInitialized = $slick.hasClass('slick-initialized');

        const breakPoint = CUSTOM_BREAKPOINT_MEDIUM - 1;
        const mobileSlide = $(this).data('mobileSlide');
        const slideNum = $slick.data('slideNum');

        let maxSlideNum;
          
        const mediaQueryTablet = window.matchMedia('(max-width: 749px)');
        const mediaQueryMobile = window.matchMedia('(max-width: 559px)');

        function updateSliderBySlideCount() {
            if (mediaQueryTablet.matches) {
                maxSlideNum = 1;
            } else if (mediaQueryMobile.matches) {
                maxSlideNum = 2;
            }

            if (slideNum <= maxSlideNum) {
                $slick.addClass('c-stack-slick');
                if (isSlickInitialized) {
                    $slick.slick('unslick');
                    isSlickInitialized = false;
                }
            } else {
                $slick.removeClass('c-stack-slick');
                if (isSlickInitialized) {
                    initializeSlick($slick);
                }
            }
        }

        updateSliderBySlideCount();
        const debouncedUpdateSlider = customDebounce(updateSliderBySlideCount, CUSTOM_DEBOUNCE_DELAY);
        mediaQueryTablet.addListener(debouncedUpdateSlider);
        mediaQueryMobile.addListener(debouncedUpdateSlider);

        function initializeSlick($slick) {
            $slick.not('.slick-initialized').slick({
                autoplay: false,
                arrows: false,
                dots: false,
                slidesToShow: 2.45,
                slidesToScroll: 2,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 560,
                        settings: {
                            slidesToShow: 1.45,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });
            isSlickInitialized = true;
        }
      
        function handleSlickResponsive() {
            const windowWidth = $(window).width();
            const isMobileView = windowWidth <= breakPoint;
        
            if (!mobileSlide) {
                if (isSlickInitialized) {
                    $slick.slick('unslick');
                    isSlickInitialized = false;
                }
                return;
            }
        
            if (isMobileView) {
                if (!isSlickInitialized) {
                    initializeSlick($slick);
                }
            } else {
                if (isSlickInitialized) {
                    $slick.slick('unslick');
                    isSlickInitialized = false;
                }
            }
        }

        handleSlickResponsive();
        const debouncedHandleSlickResponsive = customDebounce(handleSlickResponsive, CUSTOM_DEBOUNCE_DELAY);
        window.addEventListener('resize', debouncedHandleSlickResponsive);
    });
};


/****************************************
     最近チェックした商品一覧のJS
****************************************/
function initCustomRecentlyViewedSlider() {
    const recentlyViewedSections = document.querySelectorAll('.c-recently-viewed-products');
    if (recentlyViewedSections.length) {
        setupCustomRecentlyViewedSlider(recentlyViewedSections);
    }
}

function setupCustomRecentlyViewedSlider(sections) {
    sections.forEach((section) => {
        let isLoaded = false;

        const extractSectionId = (element) => {
            const section = element.closest(".shopify-section");
            return section ? section.id.replace("shopify-section-", "") : null;
        };

        const getSearchQueryString = (element) => {
            const items = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]"));
            if (element.hasAttribute("exclude-id")) {
                items.delete(parseInt(element.getAttribute("exclude-id")));
            }
            return Array.from(items.values(), (item) => `id:${item}`).slice(0, parseInt(element.getAttribute("products-count"))).join(" OR ");
        };

        const loadProducts = async (element) => {
            if (isLoaded) return;
            isLoaded = true;

            const sectionId = extractSectionId(element);
            if (!sectionId) {
                console.error('Section ID could not be extracted');
                return;
            }

            const queryString = getSearchQueryString(element);
            const url = `${Shopify.routes.root}search?type=product&q=${queryString}&section_id=${sectionId}`;

            try {
                const response = await fetch(url, { priority: "low" });
                if (!response.ok) throw new Error('Network response was not ok');

                const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html");
                const recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");

                if (recentlyViewedProductsElement && recentlyViewedProductsElement.childElementCount > 0) {
                    element.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);

                  setTimeout(() => {
                    section.classList.add('is-visible');
                    initCustomProductSlider();
                  }, '500');
                } else {
                    element.closest(".shopify-section").remove();
                }
            } catch (error) {
                console.error('Fetch error:', error);
            }
        };

        loadProducts(section);
    });
}


/****************************************
    カーソルの切り替えJS
****************************************/
function initCustomCursor() {
    const aboutusSections = document.querySelectorAll('.c-aboutus__section');
    if (aboutusSections.length) {
        setupCustomCursor(aboutusSections);
    }
};

function setupCustomCursor(sections) {
    const sectionList = sections;
    const mediaQuery = window.matchMedia(`(min-width: ${CUSTOM_BREAKPOINT_MEDIUM}px)`);

    function handleMediaQuery(e) {
        sectionList.forEach(function(section) {
            const cursor = section.querySelector('.c-aboutus__cursor');
            const btn = section.querySelector('.c-morebtn__btn');
            const href = btn.getAttribute('href');

            if (e.matches) {
                switchCursor(section, cursor);
                handleLink(section, href);
            } else {
                removeEventListeners(section);
            }
        });
    }

    function switchCursor(section, cursor) {
        let isMouseInSection = false;

        section.addEventListener('mouseenter', function() {
            isMouseInSection = true;
            cursor.classList.add('c-cursor--hover');
        });
        
        section.addEventListener('mouseleave', function() {
            isMouseInSection = false;
            cursor.classList.remove('c-cursor--hover');
        });

        section.addEventListener('mousemove', function (e) {
            if (isMouseInSection) {
                cursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
            }
        });

        window.addEventListener('scroll', function() {
            const rect = section.getBoundingClientRect();
            const mouseX = event.clientX;
            const mouseY = event.clientY;

            if (mouseX < rect.left || mouseX > rect.right || 
                mouseY < rect.top || mouseY > rect.bottom) {
                isMouseInSection = false;
                cursor.classList.remove('c-cursor--hover');
            }
        });
    }

    function handleLink(section, href) {
        section.addEventListener('click', function(e) {
            e.preventDefault();
            window.location.href = href;
        });
    }

    function removeEventListeners(section) {
        section.removeEventListener('mouseenter', function() {});
        section.removeEventListener('mouseleave', function() {});
        section.removeEventListener('mousemove', function() {});
        section.removeEventListener('click', function() {});
        window.removeEventListener('scroll', function() {});
    }

    handleMediaQuery(mediaQuery);
    mediaQuery.addListener(handleMediaQuery);
}


/****************************************
     トップへ戻るボタン
****************************************/
function initCustomSmoothScroll() {
    const smoothScrollEl = document.querySelector('.c-smoothscroll');
    if (smoothScrollEl) {
        setupCustomSmoothScroll(smoothScrollEl);
    }
};

function setupCustomSmoothScroll(smoothScrollEl) {
    let VIEW_OFFSET = 160;
  
    function viewSmoothScroll() {
        if (window.pageYOffset > VIEW_OFFSET) {
            smoothScrollEl.classList.add('c-view');
        } else {
            smoothScrollEl.classList.remove('c-view');
        }
    }

    function handleResize() {
        if (window.innerWidth <= CUSTOM_BREAKPOINT_MEDIUM && smoothScrollEl.classList.contains('c-hidden')) {
            smoothScrollEl.classList.remove('c-view');
            window.removeEventListener('scroll', viewSmoothScroll);
        } else {
            viewSmoothScroll();
            window.addEventListener('scroll', viewSmoothScroll);
        }
    }

    smoothScrollEl.addEventListener('click', function() {
        window.scroll({ top: 0, behavior: "smooth" });
    });

    const debouncedHandleResize = customDebounce(handleResize, CUSTOM_DEBOUNCE_DELAY);
    window.addEventListener("resize", debouncedHandleResize, false);
    handleResize();
}


/****************************************
     ドロワーメニューの開閉JS
****************************************/
$(document).ready(function() {
    $(document).on('click', '.c-toggle__title', function() {
        $(this).next('.c-toggle__content').slideToggle();
        $(this).toggleClass('is-active');
    });
});